import { Breadcrumbs } from 'react-daisyui';
import { FolderOpenIcon } from '@heroicons/react/24/solid';
import type { Folder } from '@types';
import { isRootFolder } from '@/components/FileBrowser/utils';

// eslint-disable-next-line import/prefer-default-export
export function FolderNavPath({
  folders,
  onFolderSelect,
}: {
  folders: Folder[];
  onFolderSelect: (folders: Folder[]) => void;
}) {
  return (
    <Breadcrumbs
      className='sticky top-0 w-full bg-base-100 flex-shrink-0 text-xs md:text-sm flex p-4'
      data-testid='folder-nav-path'
    >
      {folders.map((folder, index) => (
        <Breadcrumbs.Item
          className={`font-bold cursor-pointer ${
            isRootFolder(folder) ? 'text-white' : ''
          } hover:text-primary`}
          key={folder.id}
          onClick={() => onFolderSelect(folders.slice(0, index + 1))}
        >
          <FolderOpenIcon className='w-5 mr-2' />
          {folder.name ?? '/'}
        </Breadcrumbs.Item>
      ))}
    </Breadcrumbs>
  );
}
